import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { IItineranteListProps } from "../../../types/itinerante";
import { useItineranteCidadesLista } from "../../../hooks/queries/itinerante/useItineranteCidadesLista/useItineranteCidadesLista";
import { ISelectOptions } from "../../../types/inputs";
import { Tracking } from "../../../services/Tracking";

const schema = z.object({
  cidade: z.string().min(1, "Você precisa selecionar uma cidade"),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
});

export const useFormFilterItineranteV2 = () => {
  const { buscarCidades } = useItineranteCidadesLista();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IItineranteListProps>({
    defaultValues: {
      cidade: "",
      dataInicio: "",
      dataFim: "",
    },
    resolver: zodResolver(schema),
    mode: "all",
  });

  const getCidades = async (nome: string): Promise<ISelectOptions[]> => {
    return buscarCidades(nome)
      .then((cidades) =>
        cidades.map((cidade) => ({ value: cidade, label: cidade })),
      )
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          Tracking.error(
            "mapa:agendamento/itinerantes:buscar-cidades-falhou",
            { mensagem },
          );
          toast.error(mensagem);
          return [];
        },
      );
  };

  return {
    Controller,
    control,
    handleSubmit,
    errors,
    getCidades,
  };
};
